module.exports = __webpack_public_path__ + "img/wallpaper-whatsapp.adbccee0.jpg";